{
  "blocks": [
    {
      "id": "proc-fertilization-icsi",
      "kind": "procedure",
      "tags": ["ivf", "lab", "both-partners"],
      "title": "Fertilization & ICSI",
      "subtitle": "Combining eggs and sperm in the lab: conventional IVF or direct injection",
      "body": {
        "procedureName": "Fertilization & ICSI",
        "category": "lab",
        "description": "Combining eggs and sperm in the lab. Conventional IVF lets sperm find eggs naturally; ICSI injects one sperm directly into each egg.",
        "howItWorks": "After retrieval, mature eggs are either mixed with prepared sperm (conventional IVF) or individually injected with a single sperm using a microscopic needle (ICSI). ICSI is used when sperm counts are low, motility is poor, or previous fertilization has failed. Fertilization is checked 16-18 hours later. On average, 70-80% of mature eggs fertilize normally with ICSI, and 50-70% with conventional IVF.",
        "duration": "Same day as retrieval; results next morning",
        "costRange": {
          "low": 1500,
          "high": 3000
        },
        "currency": "USD",
        "whatToExpect": [
          "Eggs are assessed for maturity immediately after retrieval",
          "Fertilization method is chosen based on your situation",
          "Results are reported next morning (Day 1)",
          "You'll learn how many eggs fertilized normally"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "Fertilization is usually checked 16-18 hours after insemination or ICSI, so many clinics call with a Day 1 update the next morning."
          },
          {
            "label": "What you learn",
            "detail": "The update usually includes how many mature eggs fertilized normally. Some clinics also note abnormal fertilization."
          },
          {
            "label": "What comes next",
            "detail": "Normally fertilized embryos continue in culture, with later updates around Day 3 and Day 5-7 depending on clinic policy."
          }
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Fécondation & ICSI",
          "description": "Mise en contact des ovocytes et des spermatozoïdes au laboratoire. La FIV (fécondation in vitro) conventionnelle laisse les spermatozoïdes pénétrer l'ovocyte spontanément ; l'ICSI (injection intracytoplasmique de spermatozoïde) consiste à injecter directement un spermatozoïde dans chaque ovocyte.",
          "howItWorks": "Après la ponction, les ovocytes matures sont soit mis en contact avec les spermatozoïdes préparés (FIV conventionnelle), soit injectés individuellement avec un seul spermatozoïde à l'aide d'une micropipette (ICSI). L'ICSI est indiquée en cas de numération basse, de mobilité altérée ou d'échec de fécondation antérieur. La fécondation est contrôlée 16 à 18 heures plus tard. En moyenne, 70 à 80 % des ovocytes matures sont fécondés normalement en ICSI, contre 50 à 70 % en FIV conventionnelle.",
          "duration": "Le jour même de la ponction ; résultats le lendemain matin",
          "whatToExpect": [
            "La maturité des ovocytes est évaluée immédiatement après la ponction",
            "La méthode de fécondation est choisie selon votre situation",
            "Les résultats sont communiqués le lendemain matin (J1)",
            "Vous saurez combien d'ovocytes ont été fécondés normalement"
          ],
          "results": [
            {
              "label": "Quand vous avez des nouvelles",
              "detail": "La fécondation est habituellement contrôlée 16 à 18 heures après l'insémination ou l'ICSI. Beaucoup de centres appellent donc le lendemain matin, à J1."
            },
            {
              "label": "Ce que vous apprenez",
              "detail": "Le point indique généralement combien d'ovocytes matures ont été fécondés normalement. Certains centres signalent aussi les fécondations anormales."
            },
            {
              "label": "Et ensuite",
              "detail": "Les embryons fécondés normalement poursuivent leur culture, avec d'autres points vers J3 puis J5-J7 selon le protocole du centre."
            }
          ]
        }
      },
      "sources": [
        {
          "title": "Intracytoplasmic sperm injection (ICSI) for non-male factor indications: a committee opinion",
          "authors": "Practice Committees of the ASRM and SART",
          "journal": "Fertility and Sterility",
          "year": 2020,
          "url": "https://pubmed.ncbi.nlm.nih.gov/32654822/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Good practice recommendations on add-ons in reproductive medicine",
          "authors": "ESHRE Add-ons working group; Lundin K, Bentzen JG, et al.",
          "journal": "Human Reproduction",
          "year": 2023,
          "url": "https://pubmed.ncbi.nlm.nih.gov/37747409/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
